export enum TipoCulturaAtividadeEnum {
  Primaria = 1,
  Secundaria = 2,
  Outros = 3
}
